/**
 * Central configuration for mobile-related functionality
 */

export const MobileConfig = {
  // Breakpoints
  breakpoints: {
    mobile: '768px',
  },
  
  // Timings
  timings: {
    buttonResetDelay: 50,
    visualFeedbackDelay: 100,
    longPressDelay: 300,
  },
  
  // Thresholds
  thresholds: {
    keyboardDetection: 150, // Pixel difference to detect keyboard
    minimumSwipeDistance: 30,
  },
  
  // Feature flags
  features: {
    enableMobileButtonFix: true,
    enableViewportFix: true,
    enableMobileNavAutoClose: true,
  },
  
  // Utility functions
  utils: {
    /**
     * Check if the current viewport is mobile-sized
     * @returns {boolean} True if viewport matches mobile breakpoint
     */
    isMobile() {
      return window.matchMedia(`(max-width: ${MobileConfig.breakpoints.mobile})`).matches;
    }
  }
}; 